import { ActionTree, ActionContext } from 'vuex'
import { pick } from 'lodash'
import { eventsList } from '@/helpers/eventsList'
import { IRootState, IEventsState } from '@/@types'
import { postMixpanelEvent } from '@/models/events'
import { sendBrazeEvent } from '@/utils/braze'
import { actionErrorHandling } from '@/helpers'

const actions: ActionTree<IEventsState, IRootState> = {
  sendMixpanelEvent: async (
    context: ActionContext<IEventsState, IRootState>,
    payload: { event_name: string; properties: object }
  ) => {
    if (!process.env.VUE_APP_MIXPANEL_ENABLED) return
    try {
      const sentPayload = {
        user_id:
          context.rootState.auth.userProfile.user_id || context.rootState.auth.userProfile.id,
        event_name: payload.event_name,
        properties: {
          source: 'checkout.ine.com',
          ...pick(payload.properties, eventsList[payload.event_name]),
        },
      }
      await postMixpanelEvent(sentPayload)
    } catch (error) {
      actionErrorHandling(context, error)
    }
  },
  sendBrazeEventAction: async (
    context: ActionContext<IEventsState, IRootState>,
    payload: { event_name: string; properties: object }
  ) => {
    if (!process.env.VUE_APP_BRAZE_ENABLED) return
    try {
      const { event_name, properties } = payload
      const sentPayload = {
        source: 'checkout.ine.com',
        paymentMethod: context.rootState.subscriptions.paymentMethod,
        checkoutTotal: context.rootState.subscriptions.checkoutTotal,
        '3dsFlow': context.rootState.subscriptions.isIn3dsFlow,
        planCode: context.rootGetters['shoppingCart/selectedPlan']?.merchant_id,
        productsCodes: context.rootState.shoppingCart.shoppingCart.map(
          product => product.merchant_id
        ),
        coupon: context.rootState.shoppingCart.coupon,
        ...(context.rootState.events.utmParams ? context.rootState.events.utmParams : {}),
        email: context.rootState.auth.userProfile.email,
        ...pick(properties, eventsList[payload.event_name]),
      }
      await sendBrazeEvent(event_name, sentPayload)
    } catch (error) {
      actionErrorHandling(context, error)
    }
  },
  sendGAEvent: (context: ActionContext<IEventsState, IRootState>, payload) => {
    try {
      const initEcommerce = {
        ecommerce: null,
      }
      window.dataLayer.push(initEcommerce)
      window.dataLayer.push(payload)
    } catch (error) {
      actionErrorHandling(context, error)
    }
  },
  updateDataLayer: (context: ActionContext<IEventsState, IRootState>, payload) => {
    context.commit('UPDATE_DATA_LAYER', payload)
  },
}

export default actions
